__turbopack_context__.v({
  "headerLight": "zoocasa-light-for-sale-section-module-scss-module__vn1ryW__headerLight",
  "sectionLight": "zoocasa-light-for-sale-section-module-scss-module__vn1ryW__sectionLight",
});
